export const BASE_PATH = 'http://localhost:3000';
// export const BASE_PATH = 'http://192.168.100.7:8080';
export const IMAGE_BASE_URL = `${BASE_PATH}/Uploads`;
export const BASE_PATH_BACKEND = `${BASE_PATH}/api`;

// for staging
// export const WEB_APP_URL = 'https://web.stg.learnlocal.app';

// for production
export const WEB_APP_URL = 'https://web.learnlocal.app';
